export const getMetaTags = ({
  userDOM,
  editorStateSelectors
}) => {
  const {
    selectContentModelMetaDescription
  } = editorStateSelectors;
  const metaTagsHTML = userDOM.querySelectorAll('head meta');
  const metaTags = metaTagsHTML && [...metaTagsHTML].map(metaTag => {
    const {
      name,
      content
    } = metaTag;
    return {
      name,
      content
    };
  });
  const metaDescriptionContent = selectContentModelMetaDescription();
  const metaDescription = metaTags.find(metaTag => metaTag.name === 'description');
  if (metaDescription) {
    metaDescription.content = metaDescriptionContent;
  } else {
    metaTags.push({
      name: 'description',
      content: metaDescriptionContent
    });
  }
  return metaTags;
};